import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SolarIcon from 'components/icons/SolarIcon';
import type { ReportUsersObjectFilter } from '../helper/reportUsersStorage';

interface ObjectStatusFilterProps {
    value: ReportUsersObjectFilter;
    onChange: (value: ReportUsersObjectFilter) => void;
    disabled?: boolean;
}

const ObjectStatusFilter = ({ value, onChange, disabled }: ObjectStatusFilterProps) => {
    const { t } = useTranslation(['Reports']);
    const variant = value === 'closed' ? 'danger' : 'primary';

    return (
        <Dropdown>
            <Dropdown.Toggle
                className="fs-14 px-2"
                size="sm"
                variant={variant}
                id="report-users-object-filter"
                disabled={disabled}
                title={t(`usersFilter.${value}`)}
            >
                <SolarIcon name="funnel" className="fs-14 p-0" />
            </Dropdown.Toggle>

            <Dropdown.Menu>
                <Dropdown.Item as="button" onClick={() => onChange('all')}>
                    <div className="d-flex align-items-center">
                        <input
                            type="radio"
                            className="form-check-input me-2"
                            checked={value === 'all'}
                            onChange={() => onChange('all')}
                        />
                        {t('usersFilter.all')}
                    </div>
                </Dropdown.Item>
                <Dropdown.Item as="button" onClick={() => onChange('closed')}>
                    <div className="d-flex align-items-center">
                        <input
                            type="radio"
                            className="form-check-input me-2"
                            checked={value === 'closed'}
                            onChange={() => onChange('closed')}
                        />
                        {t('usersFilter.closed')}
                    </div>
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default ObjectStatusFilter;
